//@flow
import React from 'react';
import DocumentTextIcon from '../icons/DocumentTextIcon';
import AudioSquareIcon from '../icons/AudioSquareIcon';
import VideoPlayIcon from '../icons/VideoPlayIcon';
import ImageIcon from '../icons/ImageIcon';
import EmojiIcon from '../icons/EmojiIcon';

type Props = {
  type?: string,
};

export default function FileTypeIcons(props: Props) {
  const {type = ''} = props;

  if (type.includes('image')) {
    return <ImageIcon />;
  }

  if (type.includes('audio')) {
    return <AudioSquareIcon />;
  }

  if (type.includes('video')) {
    return <VideoPlayIcon />;
  }

  if (type.includes('reaction')) {
    return <EmojiIcon />;
  }
  return <DocumentTextIcon />;
}
